import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import './Spinner.scss';

interface SpinnerProps {
  color: "primary" | "secondary" | "error" | "info" | "success" | "warning" | "inherit" | undefined,
  size: number,
}

const defaultProps = {
  color: 'primary',
  size: 40,
};

const Spinner = ({ color, size } : SpinnerProps) => (
    <div className='spinner-container'>
      <CircularProgress
        className='spinner root'
        color={color}
        size={size}
      />
    </div>
  
);

Spinner.defaultProps = defaultProps;

export default Spinner;